import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from "@/views/Main/Main";
import Landing from "@/views/Main/Landing";
import {Auth} from "@/js/caller";
import TextesList from "@/views/Textes/TextesList";
import TextesVue from "@/views/Textes/TextesVue";
import EleveList from "@/views/Eleves/EleveList";
import EleveView from "@/views/Eleves/EleveView";
import LeconVue from "@/views/Lecons/LeconVue";
import ProduitList from "@/views/Produits/ProduitList";
import ProduitVue from "@/views/Produits/ProduitVue";
import LeconElemVue from "@/views/Lecons/LeconElemVue";
import ForgotPassword from "@/views/ForgotPassword";
import ResetPasswordVue from "@/views/ResetPasswordVue";
import ActivateVue from "@/views/Produits/ActivateVue";
import MessagerieVue from "@/views/Messagerie/MessagerieVue";
import ExerciceList from "@/views/Exercices/ExerciceList";
import ExerciceEditor from "@/views/Exercices/ExerciceEditor";
import ContenuPrincipalVue from "@/views/Admin/ContenuPrincipal/ContenuPrincipalVue";
import ContenuPrincipalListVue from "@/views/Admin/ContenuPrincipal/ContenuPrincipalListVue";
import ProduitListVue from "@/views/Admin/Produits/ProduitListVue";
import ProduitEditorVue from "@/views/Admin/Produits/ProduitEditorVue";
import MailListVue from "@/views/Eleves/MailListVue";
import DialogueCreatorView from "@/views/Admin/DialogueCreatorView";

Vue.use(VueRouter)

const routes = [
  //Main
  {
    path     : '/',
    name     : Main.name,
    component: Main
  },
  {
    path     : '/inscription',
    name     : Landing.name,
    component: Landing
  },
  {
    path     : '/reset',
    name     : ForgotPassword.name,
    component: ForgotPassword
  },
  {
    path     : '/reset/:token',
    name     : ResetPasswordVue.name,
    component: ResetPasswordVue
  },
  //Textes
  {
    path     : '/textes',
    name     : TextesList.name,
    component: TextesList
  },
  {
    path     : '/textes/:id',
    name     : TextesVue.name,
    component: TextesVue
  },
  // ADMIN
  // --Eleves
  {
    path     : '/admin/eleves',
    name     : EleveList.name,
    component: EleveList
  },
  {
    path     : '/admin/eleves/liste-mail',
    name     : MailListVue.name,
    component: MailListVue
  },
  {
    path     : '/admin/eleves/:id',
    name     : EleveView.name,
    component: EleveView
  },
  // --Exercices
  {
    path     : '/admin/exercices',
    name     : ExerciceList.name,
    component: ExerciceList
  },
  {
    path     : '/admin/exercices/:id',
    name     : ExerciceEditor.name,
    component: ExerciceEditor
  },
  // --Principal
  {
    path     : '/admin/contenu_principal',
    name     : ContenuPrincipalListVue.name,
    component: ContenuPrincipalListVue
  },
  {
    path     : '/admin/contenu_principal/:id',
    name     : ContenuPrincipalVue.name,
    component: ContenuPrincipalVue
  },
  // --Produits
  {
    path     : '/admin/produits',
    name     : ProduitListVue.name,
    component: ProduitListVue
  },
  {
    path     : '/admin/produits/:id',
    name     : ProduitEditorVue.name,
    component: ProduitEditorVue
  },
  // Utils
  {
    path     : '/admin/dialogues',
    name     : DialogueCreatorView.name,
    component: DialogueCreatorView
  },
  // DALF, DELF
  {
    path     : '/lecon/:niveau',
    name     : LeconVue.name,
    component: LeconVue
  },
  {
    path     : '/lecon/:niveau/:id',
    name     : LeconElemVue.name,
    component: LeconElemVue
  },
  // Produits
  {
    path     : '/exercices',
    name     : ProduitList.name,
    component: ProduitList
  },
  {
    path     : '/exercices/activate',
    name     : ActivateVue.name,
    component: ActivateVue
  },
  {
    path     : '/exercices/:id',
    name     : ProduitVue.name,
    component: ProduitVue
  },
  //Messagerie
  {
    path     : '/messagerie',
    name     : MessagerieVue.name,
    component: MessagerieVue
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (![Landing.name, ForgotPassword.name, ResetPasswordVue.name].includes(to.name) && !Auth.IsLogged())
    next({name: Landing.name})
  else if (to.name === Landing.name && Auth.IsLogged()) next({name: Main.name})
  else next()
});

Auth.Register(Auth.Events.Logout, () => {
  router.push({name: Landing.name});
});

export default router
